import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import SecondaryButtonSmall from "../designSystem/buttons/SecondaryButtonSmall";
import TextButton from "../designSystem/buttons/TextButton";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import SEO from "../designSystem/SEO";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import Accordion from "../designSystem/Accordion";
import InsuranceProtection1 from "../../assets/images/insurance_whyconsider.png";
import InsuranceProtection2 from "../../assets/images/inurance_lifeinsurance.png";
import InsuranceProtection3 from "../../assets/images/insurance_criticalillnesscover.png";
import InsuranceProtection4 from "../../assets/images/insurance_homebuyers.png";

import { ReactComponent as One } from "../../assets/icons/1.svg";
import { ReactComponent as Two } from "../../assets/icons/2.svg";
import { ReactComponent as Three } from "../../assets/icons/3.svg";
import { ReactComponent as Four } from "../../assets/icons/4.svg";
import { ReactComponent as Five } from "../../assets/icons/5.svg";
import { ReactComponent as Six } from "../../assets/icons/6.svg";
import { ReactComponent as Seven } from "../../assets/icons/7.svg";
import { ReactComponent as Eight } from "../../assets/icons/8.svg";

const InsuranceProtectionPage = () => {
  return (
    <div>
      <SEO
        title="Insurance and Protection"
        description="Straightforward life insurance, critical illness cover and home buyers protection advice to help protect your home, income and loved ones."
        path="/insurance-protection"
      />
      <Hero
        title={`protecting what matters most`}
        subtitle="Insurance & protection"
        titleAlign="center"
        subtitleAlign="center"
      >
        <div className="column-center gap-s">
          <div className="content text-primary-1">
            Buying a home is one of the biggest financial commitments you'll
            ever make. While securing the right mortgage is important,
            protecting your home, income and loved ones is equally essential. At
            AK Mortgages, we provide straightforward advice on a range of
            protection solutions designed to give you and your family peace of
            mind should the unexpected happen.
          </div>
          <div className="content text-primary-1">
            We'll help you understand your options, explain cover in simple
            terms, and recommend protection that suits your circumstances and
            budget.
          </div>
        </div>
      </Hero>
      <div
        id="why-consider-protection"
        className="background-container bg-white"
      >
        <div className="content-container row-center grid2 gap-xxxxxl row-center">
          <img
            src={InsuranceProtection1}
            alt="Family reviewing protection insurance options"
            className="hero-image"
          />
          <div className="column gap-l">
            <h2 className="text-primary-1 uppercase">
              Why consider protection?
            </h2>
            <div className="column gap-m">
              <div className="content text-primary-1">
                Life can be unpredictable. Illness, injury, loss of income or
                death can have a significant financial impact on you and your
                family. The right protection can help ensure that:
              </div>
              <div className="content text-primary-1">
                <ul className="content text-primary-1 column gap-m">
                  <li>Your mortgage payments remain affordable</li>
                  <li>Your loved ones are financially secure</li>
                  <li>You have support during difficult times</li>
                  <li>Your home and lifestyle are protected</li>
                </ul>
              </div>
              <div className="content text-primary-1">
                Our advice is always tailored to your individual needs, helping
                you make informed decisions with confidence.
              </div>
            </div>
            <div className="body2 text-primary-1">
              Protection plans are subject to terms and conditions. The
              availability and cost of cover depend on individual circumstances.
            </div>
            <div className="row-flex-start gap-s">
              <PrimaryButton text="Book a free initial appointment" />
              <TertiaryButton text="Read FAQs" />
            </div>
          </div>
        </div>
      </div>
      <div id="life-insurance" className="background-container bg-gray-3">
        <div className="content-container row-reverse gap-xxxxxl">
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              Life insurance
            </div>
            <h3 className="text-primary-1 uppercase">
              Financial Security for Your Loved Ones
            </h3>
            <div className="column gap-m">
              <div className="content text-primary-1">
                Life insurance is designed to provide a lump sum payment if you
                pass away during the policy term. This can help your family
                manage ongoing expenses, repay outstanding debts, or clear the
                mortgage on your home.
              </div>
              <div className="content text-primary-1">
                For many homeowners, life insurance provides reassurance that
                their loved ones will have financial support when they need it
                most. Benefits of life insurance:
              </div>
              <div className="content text-primary-1">
                <ul className="content text-primary-1 column gap-m">
                  <li>Help protect your family's financial future</li>
                  <li>Potentially cover outstanding mortgage</li>
                  <li>Provide financial support for dependants</li>
                  <li>Peace of mind for you and your loved ones</li>
                </ul>
              </div>
              <div className="content text-primary-1">
                Every family is different, which is why we'll help you find
                cover that reflects your circumstances and priorities.
              </div>
            </div>
            <div className="row-flex-start gap-s">
              <PrimaryButton text="Book a free initial appointment" />
              <TertiaryButton text="Read FAQs" />
            </div>
          </div>
          <img
            src={InsuranceProtection2}
            alt="Life insurance advice for homeowners"
            className="hero-image"
          />
        </div>
      </div>

      <div id="critical-illness-cover" className="background-container">
        <div className="content-container row gap-xxxxxl">
          <img
            src={InsuranceProtection3}
            alt="Critical illness cover consultation"
            className="hero-image"
          />
          <div className="column gap-l">
            <div className="column gap-s">
              <div className="subtitle-semibold  text-primary-2 uppercase">
                Critical illness cover
              </div>
              <h3 className="text-primary-1 uppercase">
                Protection when you need it most
              </h3>
            </div>
            <div className="column gap-m">
              <div className="content text-primary-1">
                A serious illness can impact more than your health—it can affect
                your finances, lifestyle and ability to work. Critical Illness
                Cover provides a lump sum payment if you're diagnosed with a
                specified serious illness covered by the policy. This financial
                support can help you focus on recovery without worrying about
                immediate financial pressures. Critical Illness Cover May Help
                With:
              </div>
              <div className="content text-primary-1">
                <ul className="content text-primary-1 column gap-m">
                  <li>Mortgage repayments</li>
                  <li>Household bills and living expenses</li>
                  <li>Time away from work</li>
                  <li>Medical and recovery-related costs</li>
                  <li>Maintaining your family's lifestyle</li>
                </ul>
              </div>
              <div className="content text-primary-1">
                We'll explain the different options available and help you
                understand what level of cover may be suitable for your needs.
              </div>
            </div>
            <div className="row-flex-start gap-s">
              <PrimaryButton text="Book a free initial appointment" />
              <TertiaryButton text="Read FAQs" />
            </div>
            <div className="body2 text-primary-1">
              Protection plans are subject to terms and conditions. The
              availability and cost of cover depend on individual circumstances.
            </div>
          </div>
        </div>
      </div>
      <div id="income-protection" className="background-container bg-primary-1">
        <div className="content-container row-flex-start row  gap-xxxxxl">
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              income protection
            </div>
            <h2 className="text-white uppercase">
              protecting your income when you need it most
            </h2>
            <div className="column gap-m">
              <div className="content text-white">
                Your income pays for your mortgage, bills and everyday living
                costs. If you were unable to work due to illness or injury,
                income protection can help replace part of your income so you
                can stay financially stable while you recover.
              </div>

              <div className="content text-white">
                At AK Mortgages, we provide simple, honest advice on income
                protection and help you choose cover that suits you.
              </div>
            </div>
          </div>
          <div className="column gap-l">
            <h3 className="text-white uppercase">
              why consider income protection?
            </h3>
            <div className="column gap-m">
              <div className="content text-white">
                If you cannot work, your income may reduce or stop completely.
                Income protection can help you:
              </div>
              <div className="content text-white">
                <ul className="content text-white column gap-m">
                  <li>Keep up with mortgage or rent payments</li>
                  <li>Cover household bills and essential costs</li>
                  <li>Maintain financial stability while off work</li>
                  <li>Avoid using savings or taking on debt</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="home-buyers-protection"
        className="background-container bg-gray-3"
      >
        <div className="content-container row gap-xxxxxl">
          <img
            src={InsuranceProtection4}
            alt="Home buyers protection advice"
            className="hero-image"
          />
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              home buyers protection
            </div>
            <h3 className="text-primary-1 uppercase">
              Additional Protection During Your Property Purchase
            </h3>
            <div className="column gap-m">
              <div className="content text-primary-1">
                Buying a property often involves upfront costs such as surveys,
                legal fees and mortgage application expenses. Home Buyers
                Protection can help cover certain costs if your purchase falls
                through due to circumstances outside your control, giving you
                additional peace of mind during the buying process. Potential
                Benefits Include:
              </div>
              <div className="content text-primary-1">
                <ul className="content text-primary-1 column gap-m">
                  <li>Protection against failed purchase costs</li>
                  <li>Added confidence during home-buying</li>
                  <li>Financial support if unforeseen issues arise</li>
                </ul>
              </div>
            </div>
            <div className="content text-primary-1">
              We'll explain how this type of cover works and whether it's
              appropriate for your situation.
            </div>
            <div className="row-flex-start gap-s">
              <PrimaryButton text="Book a free initial appointment" />
              <TertiaryButton text="Read FAQs" />
            </div>
          </div>{" "}
        </div>
      </div>

      <div className="background-container bg-gray-1">
        <div className="content-container column gap-l">
          <div className="column gap-m">
            <div className="subtitle-semibold  text-white uppercase">
              Protect Your Home, Your Income & Your Family
            </div>
            <div className="column gap-s">
              <div className="content text-white">
                The right protection can provide valuable peace of mind for you
                and your loved ones.
              </div>
              <div className="content text-white">
                Book a free consultation with one of our advisers at AK
                Mortgages to discuss your protection needs and explore the
                options available to you.
              </div>
            </div>
            <PrimaryButton
              text="book a free initial appointment"
              onClick={() =>
                window.open(
                  "https://bookings.cloud.microsoft/bookwithme/user/fa2261725ab84f21bb747357792d358b%40akmortgages.uk?anonymous&ismsaljsauthenabled",
                  "_blank",
                )
              }
            />
          </div>
          <div className="body2 text-white">
            Protection plans are subject to terms and conditions. The
            availability and cost of cover depend on individual circumstances.
          </div>
        </div>
      </div>
      <div
        id="faqs"
        data-section="faqs"
        className="background-container bg-gray-3"
      >
        <div className="content-container column gap-xxl">
          <h3 className="text-primary-1 uppercase">
            frequently asked questions
          </h3>
          <div className="column gap-m">
            <Accordion
              title="House and building contents when does this need to be set up?"
              children={
                <div>
                  Most lenders will want this to go live at exchange of
                  contracts (this is when you become legally binding on the
                  property).
                </div>
              }
            />
            <Accordion
              title="Do I Need Life Insurance To Get A Mortgage?"
              children={
                <div>
                  Life insurance is not usually a requirement for obtaining a
                  mortgage, but many homeowners choose to put cover in place to
                  help protect their family's financial future.
                </div>
              }
            />
            {/* <Accordion
              title="Do I Need Life Insurance To Get A Mortgage?"
              children={
                <div>
                  Life insurance is not usually a requirement for obtaining a
                  mortgage, but many homeowners choose to put cover in place to
                  help protect their family's financial future.
                </div>
              }
            /> */}
            <Accordion
              title="Can I Arrange Protection If I Already Have A Mortgage?"
              children={
                <div>
                  Yes. Protection can be reviewed and arranged at any stage,
                  whether you're buying a new property or have owned your home
                  for years.
                </div>
              }
            />
            <Accordion
              title="How Much Cover Do I Need?"
              children={
                <div>
                  The amount of cover depends on your personal circumstances,
                  including your mortgage balance, income, family commitments
                  and financial goals.
                </div>
              }
            />
            <Accordion
              title="Will You Explain The Different Options?"
              children={
                <div>
                  Absolutely. We believe protection advice should be clear and
                  easy to understand, helping you make informed decisions
                  without pressure.
                </div>
              }
            />
          </div>
          <div className="body2 text-primary-1 text-center width-100">
            Your home may be repossessed if you do not keep up with repayments
            on your mortgage.
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsuranceProtectionPage;
